import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { styled } from "styled-components";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { checkForUpdates } from "../utils/jsonUtils";
import PageWrapper from "../components/PageWrapper";
import { settings } from "../data/settings";
import theme from "../theme";
import SEO from "../components/SEO";

const StyledTextSection = styled(Box)`
  padding: 2rem;
  text-align: left;
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  margin: auto;
  flex-direction: row;
  display: flex;
  align-items: center;
  align-items: flex-start;
  ${theme.breakpoints.down("sm")} {
    flex-direction: column-reverse;
  }
`;

const TitleSection = styled.div`
  flex-direction: column;
  display: flex;
  flex: 0.6;
`;
const TitleImage = styled.div`
  display: flex;
  flex: 0.4;
  max-width: 50%;
  /*height: 8rem;
  width: 8rem;*/
  ${theme.breakpoints.down("sm")} {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
    max-width: unset;
    margin-bottom: 1rem;
  }
  & img {
    background-color: black;
    /*height: 8rem;
    width: 8rem;*/
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    ${theme.breakpoints.down("sm")} {
      margin: auto;
      aspect-ratio: 1;
    }
  }
`;

const TitleText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0rem 1rem 1rem 0rem;
`;
const Title = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 2.2rem;
  font-weight: 800 !important;
  text-transform: uppercase;
  text-align: left;
  display: flex;
  align-items: flex-start;
  ${theme.breakpoints.down("sm")} {
    font-size: 1.8rem;
  }
`;

const SubTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 1.8rem;
  font-weight: 500;
  text-align: left;
  display: flex;
  align-items: flex-start;
  ${theme.breakpoints.down("sm")} {
    font-size: 1.4rem;
  }
`;
const TextSection = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: left;
  margin-top: 0.5rem;
`;

const PartenaireSection = styled.div`
  padding: 2rem;
  padding-bottom: 0rem;
  text-align: left;
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  margin: auto;
  flex-direction: row;
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  ${theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`;

const PartenaireImage = styled.div`
  flex: 0.4;
  position: relative;
  max-width: 13rem;
  max-height: 13rem;
  width: 100%;
  height: auto;
  margin: auto;
  aspect-ratio: 1 / 1; /* carré pur */
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    position: relative;
    z-index: 2;
    width: 80%;
    height: auto;
    object-fit: cover;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: inherit;
    background-size: cover;
    background-position: center;
    filter: brightness(0.85);
    z-index: 1;
  }
`;

const PartenaireTitleSection = styled.div`
  flex-direction: column;
  display: flex;
  font-size: 1rem;
  flex: 1;
`;
const PartenaireTitleText = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  font-weight: 600;
`;
const PartenaireTextSection = styled.p`
  margin: 0;
  padding: 0;
  font-size: 1rem;
`;

const EngagementsSection = styled.div`
  padding: 2rem;
  text-align: left;
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  margin: auto;
  flex-direction: column;
  display: flex;
  align-items: center;
  align-items: flex-start;
  margin-top: 2rem;
`;

const EngagementsTitleText = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 2.2rem;
  font-weight: 800 !important;
  text-transform: uppercase;
  text-align: left;
  display: flex;
  align-items: flex-start;
  ${theme.breakpoints.down("sm")} {
    font-size: 1.8rem;
  }
`;
const EngagementsListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
`;
const EngagementsItem = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
`;
const EngagementsItemImage = styled.div`
  border: 2px solid black;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.75;

  ${theme.breakpoints.down("sm")} {
    width: 2.5rem;
    height: 2.5rem;
  }

  & img {
    width: 65%;
    height: 65%;
    object-fit: cover;
  }
`;

const EngagementsItemText = styled.div``;

const PageEngagements = ({ pageKey }) => {
  const [content, setContent] = useState(null);
  const [contentMap, setContentMap] = useState(null);

  useEffect(() => {
    checkForUpdates(pageKey, setContent);
  }, [pageKey]);

  useEffect(() => {
    if (content) {
      console.log("content", content); // Transforme les données en un objet indexé par 'id'
      const elementsById = content?.elements.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
      setContentMap(elementsById);
    } else {
      setContentMap(null);
    }
  }, [content]);

  return (
    <PageWrapper style={{ backgroundColor: "#000", color: "#fff" }}>
      <SEO pageKey={pageKey} />
      {contentMap && (
        <>
          {/* Zone Texte avec Titre */}
          <StyledTextSection maxWidth={settings.pages.pageMaxWidth}>
            <TitleSection>
              <TitleText>
                <Title
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-partenaire-title"]?.content || "",
                  }}
                ></Title>
                <SubTitle
                  dangerouslySetInnerHTML={{
                    __html:
                      contentMap?.["txt-partenaire-subTitle"]?.content || "",
                  }}
                ></SubTitle>
                <TextSection
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-partenaire-text"]?.content || "",
                  }}
                ></TextSection>
              </TitleText>
            </TitleSection>
            <TitleImage>
              <img
                src={contentMap?.["img-partenaire-img"]?.content}
                alt="engagement-img"
              />{" "}
            </TitleImage>
          </StyledTextSection>

          {/* Zone Texte avec Titre */}
          <PartenaireSection maxWidth={settings.pages.pageMaxWidth}>
            <PartenaireImage bg={contentMap?.["img-main-bg"]?.content}>
              <img src={contentMap?.["img-abc-img"]?.content} alt="abc-img" />{" "}
            </PartenaireImage>
            <PartenaireTitleSection>
              <PartenaireTitleText
                dangerouslySetInnerHTML={{
                  __html: contentMap?.["txt-ABC-title"]?.content || "",
                }}
              ></PartenaireTitleText>

              <PartenaireTextSection
                dangerouslySetInnerHTML={{
                  __html: contentMap?.["txt-ABC-text"]?.content || "",
                }}
              ></PartenaireTextSection>
            </PartenaireTitleSection>
          </PartenaireSection>

          <PartenaireSection
            style={{ paddingTop: "1rem" }}
            maxWidth={settings.pages.pageMaxWidth}
          >
            <PartenaireImage bg={contentMap?.["img-main-bg"]?.content}>
              <img src={contentMap?.["img-sch-img"]?.content} alt="sch-img" />{" "}
            </PartenaireImage>
            <PartenaireTitleSection>
              <PartenaireTitleText
                dangerouslySetInnerHTML={{
                  __html: contentMap?.["txt-sch-title"]?.content || "",
                }}
              ></PartenaireTitleText>

              <PartenaireTextSection
                dangerouslySetInnerHTML={{
                  __html: contentMap?.["txt-sch-text"]?.content || "",
                }}
              ></PartenaireTextSection>
            </PartenaireTitleSection>
          </PartenaireSection>

          <EngagementsSection maxWidth={settings.pages.pageMaxWidth}>
            <EngagementsTitleText
              dangerouslySetInnerHTML={{
                __html: contentMap?.["txt-eco-title"]?.content || "",
              }}
            ></EngagementsTitleText>
            <EngagementsListSection>
              <EngagementsItem>
                <EngagementsItemImage>
                  <img
                    style={{ width: "80%", height: "80%" }}
                    src={contentMap?.["img-eco-prod"]?.content}
                    alt="img-eco-prod"
                  />
                </EngagementsItemImage>
                <TextSection
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-eco-prod"]?.content || "",
                  }}
                ></TextSection>
              </EngagementsItem>
              <EngagementsItem>
                <EngagementsItemImage>
                  <img
                    src={contentMap?.["img-eco-dech"]?.content}
                    alt="img-eco-dech"
                  />
                </EngagementsItemImage>
                <TextSection
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-eco-dech"]?.content || "",
                  }}
                ></TextSection>
              </EngagementsItem>
              <EngagementsItem>
                <EngagementsItemImage>
                  <img
                    src={contentMap?.["img-eco-ani"]?.content}
                    alt="img-eco-ani"
                  />
                </EngagementsItemImage>
                <EngagementsItemText
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-eco-ani"]?.content || "",
                  }}
                ></EngagementsItemText>
              </EngagementsItem>
              <EngagementsItem>
                <EngagementsItemImage>
                  <img
                    src={contentMap?.["img-eco-eau"]?.content}
                    alt="img-eco-eau"
                  />
                </EngagementsItemImage>
                <EngagementsItemText
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-eco-eau"]?.content || "",
                  }}
                ></EngagementsItemText>
              </EngagementsItem>
              <EngagementsItem>
                <EngagementsItemImage>
                  <img
                    src={contentMap?.["img-eco-more"]?.content}
                    alt="img-eco-more"
                  />
                </EngagementsItemImage>
                <EngagementsItemText
                  dangerouslySetInnerHTML={{
                    __html: contentMap?.["txt-eco-more"]?.content || "",
                  }}
                ></EngagementsItemText>
              </EngagementsItem>
            </EngagementsListSection>
          </EngagementsSection>
        </>
      )}
    </PageWrapper>
  );
};

export default PageEngagements;
